import locales from "@/i18n/locals.json";
import en from "./en.json";
import es from "./es.json";

export default {
    [locales.ENGLISH]: en,
    [locales.SPANISH]: es,
};
